import axios from './Api';

export function Login(data: Login.ILoginParams) {
  return axios.post<Login.ILoginResponse>('/auth/login', data);
}

export function ForgotPassword(data = {} as Auth.IForgotPassword) {
  return axios.post<Auth.IResetPasswordResponse>('/auth/forgotPassword', data);
}

export function ValidateToken(data = {} as Auth.IValidatePassword) {
  return axios.post<Axios.IResponseSuccess>('/auth/validateToken', data);
}

export function ResetPassword(data = {} as Auth.IResetPassword) {
  return axios.post<Axios.IResponseSuccess>('/auth/resetPassword', data);
}
